import React, { useState } from "react";
import { useLocation } from "react-router-dom";


export default function DropDownSidebarItems({ label, icon, children, isOpen, onToggle }) {
  const location = useLocation();

  // Use local state if props are not provided (backward compatibility)
  const [isLocalOpen, setIsLocalOpen] = useState(false);
  const isControlled = isOpen !== undefined;

  const openState = isControlled ? isOpen : isLocalOpen;

  const handleOpen = (e) => {
    e.preventDefault();
    if (isControlled) {
      onToggle();
    } else {
      setIsLocalOpen(!isLocalOpen);
    }
  };

  const sidebarItems = React.Children.toArray(children);
  const isCurrentLocation = sidebarItems.some((sidebarItem) => {
    return sidebarItem.props.goToPath === location.pathname;
  })

  // Auto-open if child is active
  React.useEffect(() => {
    if (isCurrentLocation && !openState && isControlled) {
      onToggle();
    } else if (isCurrentLocation && !openState && !isControlled) {
      setIsLocalOpen(true);
    }
  }, [isCurrentLocation]);


  return (
    <li className={isCurrentLocation ? "active" : ""}>
      <a
        href="#"
        aria-expanded={openState ? "true" : "false"}
        className={"prevent-select allow-pointer-cursor"}
        onClick={(e) => handleOpen(e)}
      >
        <i className={`color-blanco-megatone ${icon}`} />
        <span title={label} className="color-blanco-megatone hide-menu">{label}</span>
      </a>
      {openState && <ul className="background-gris-megatone">{children}</ul>}
    </li>
  );
};